import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Separator } from "@/components/ui/separator";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useEditionById } from "@/hooks/edition-by-id.hook";
import { currentEditionIdAtom } from "@/store/edition-id.store";
import { Calendar } from "iconsax-react";
import { useAtomValue } from "jotai";
import MilestonesDropdownItem from "./milestones-dropdown-item";

const MilestonesDropdown = () => {
  const editionId = useAtomValue(currentEditionIdAtom);

  const { data: userProfile } = useCurrentUserProfile();

  const { data: edition } = useEditionById({
    companyId: userProfile?.companyId || "",
    editionId,
  });

  const milestones = [...(edition?.milestones || [])].sort(
    (a, b) => a.index - b.index,
  );

  if (edition && milestones.length > 0) {
    return (
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="white" size="icon" className="[&_svg]:size-auto">
            <Calendar size={24} />
          </Button>
        </PopoverTrigger>

        <PopoverContent side="bottom" align="end">
          <div className="flex gap-2">
            <Calendar size={24} />
            <h4 className="font-bold text-[#4F5D6D]">
              Cronograma {edition.name}
            </h4>
          </div>

          <Separator className="my-4" />

          <div className="flex flex-col">
            {milestones.map((milestone) => (
              <MilestonesDropdownItem
                key={milestone.id}
                milestone={milestone}
              />
            ))}
          </div>
        </PopoverContent>
      </Popover>
    );
  }
};

export default MilestonesDropdown;
